var React = require('react');

function InformationCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}));
}

InformationCircleInline.defaultProps = {"fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"};

module.exports = InformationCircleInline;

InformationCircleInline.default = InformationCircleInline;
